exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".destination-map-popup{font-weight:700}.destination-map-popup .leaflet-popup-content{padding:30px;font-size:18px}", ""]);

